<div class="progress-bar">
    <div class="bar">
        <div class="progress" [style.width]="progressBarWidth()"></div>
    </div>
    <div class="status-labels">
        @for (status of statuses(); track status; let i = $index) {
            <div class="status body-1" [class.active]="i <= getStatusIndex(currentStatus())">
                {{ status }}
            </div>
        }
    </div>
</div>
